// Legislative districts are stored as in the legislators table: 'AD62' (Assembly) and 'SD27' (Senate).

const HOUSE_NAMES = { AD: "Assembly", SD: "Senate" };

export function districtLabel(district) {
    const match = /^(AD|SD)0*(\d+)$/i.exec(district || "");
    return match ? `${HOUSE_NAMES[match[1].toUpperCase()]} District ${match[2]}` : district || "";
}

// "district", "dist"; ignored when searching so "district 27" finds the same people as "27"
export function isDistrictFiller(part) {
    return part === "district" || part === "dist";
}

// True when one search word names this district: "AD62", "sd27", "a62", or a bare number ("62", "07").
// A bare number matches either house; with a prefix it must be that house.
export function matchesDistrict(part, district) {
    const match = /^(ad|sd|a|s)?0*(\d{1,2})$/.exec(part || "");
    const code = /^(AD|SD)0*(\d+)$/i.exec(district || "");
    if (!match || !code) return false;
    if (parseInt(match[2], 10) !== parseInt(code[2], 10)) return false;
    return !match[1] || match[1][0] === code[1][0].toLowerCase();
}

// Rewrites the ways people type a district into one word ("ad62" / "sd27") so a search that splits on
// spaces sees it whole: "AD 62", "ad-62", "A.D. #62", "SD # 7", "assembly district 62", "senate 27".
// A district typed with no house ("district 27", "#27", "27") is left as the bare number.
export function normalizeDistrictQuery(text) {
    const house = (code) => (match, lead, num) => `${lead}${code}${parseInt(num, 10)}`;
    return String(text || "")
        .toLowerCase()
        .replace(/(^|[^a-z0-9])(?:a\.?\s?d\.?|assembly)(?:\s*(?:district|dist\.?))?\s*(?:#|no\.?|-)?\s*0*(\d{1,2})(?!\d)/g, house("ad"))
        .replace(/(^|[^a-z0-9])(?:s\.?\s?d\.?|senate)(?:\s*(?:district|dist\.?))?\s*(?:#|no\.?|-)?\s*0*(\d{1,2})(?!\d)/g, house("sd"))
        .replace(/#/g, " ");
}
